module.exports = __webpack_public_path__ + "img/Auditoria.c7239d73.jpg";